import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { conciergeModalities, CONTACT } from '../../data/modalities';
export function ConciergeSuite() {
  return <section id="concierge" className="w-full bg-navy py-20 text-white sm:py-24" data-id="element-141" data-mp="28ez1170gatqc">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-142" data-mp="23fvvllgk6lhu">
        <div className="grid items-center gap-12 lg:grid-cols-[0.9fr_1.1fr]" data-id="element-143" data-mp="1yfq88hhbnl5k">
          <div data-id="element-144" data-mp="2w2ynvvun5zzn">
            <p className="text-[12px] font-semibold uppercase tracking-[0.16em] text-teal-light" data-id="element-145" data-mp="2w1f7m58zjoxv">
              Concierge Modality Suite
            </p>
            <h2 className="mt-3 font-display text-3xl font-bold leading-tight tracking-tight sm:text-[2.4rem]" data-id="element-146" data-mp="2r5q7o0t20611">
              A curated system around your doctor needs
            </h2>
            <p className="mt-5 text-[16px] leading-relaxed text-white/80" data-id="element-147" data-mp="2hbge4fsdl1oq">
              The Concierge Modality Suite is not a product bundle. It is a
              consultative way to consider complementary technologies together,
              then select a coordinated system that makes sense for your
              patients, team, and practice goals.
            </p>
            <a href={CONTACT.phoneHref} className="mt-8 inline-flex items-center gap-2 rounded-full bg-teal px-7 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-navy" data-id="element-148" data-mp="ifkk9ncp76g9">
              <PhoneIcon className="h-[18px] w-[18px]" data-id="element-149" data-mp="3vwa3wdjk401o" />
              Call About the Suite
            </a>
          </div>
          <div className="relative grid grid-cols-2 gap-4 sm:grid-cols-3" data-id="element-150" data-mp="3hx0vw15i8c8s">
            {conciergeModalities.map(modality => <div key={modality.name} className="rounded-2xl border border-white/15 bg-white/[0.07] p-4 transition-colors hover:border-teal/60 hover:bg-white/[0.1]" data-id="element-151" data-mp="3mx6iv40txakj">
                <div className="mb-3 h-1 w-8 rounded-full bg-teal" data-id="element-152" data-mp="1l1cxy0hvynj2" />
                <p className="font-display text-[14px] font-bold leading-tight text-white" data-id="element-153" data-mp="1iqlut6ss6epd">
                  {modality.name}
                </p>
                <p className="mt-1.5 text-[12px] leading-snug text-white/70" data-id="element-154" data-mp="19o47sq5axi1b">
                  {modality.desc}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}